import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import { CompetitionPicker } from '@/features/admin/components/CompetitionPicker'
import { GameweekTable } from '@/features/admin/components/GameweekTable'
import { SyncTeamsForm } from '@/features/admin/components/SyncTeamsForm'
import { SyncScheduleForm } from '@/features/admin/components/SyncScheduleForm'
import { SeedRostersForm } from '@/features/admin/components/SeedRostersForm'
import { SyncInjuriesForm } from '@/features/admin/components/SyncInjuriesForm'
import { SyncEliminationsForm } from '@/features/admin/components/SyncEliminationsForm'
import { PricePreviewForm } from '@/features/admin/components/PricePreviewForm'
import styles from './fantasy.module.css'

type AdminFantasySearch = {
  competitionId?: string
}

export const Route = createFileRoute('/_authenticated/admin/fantasy')({
  validateSearch: (search: Record<string, unknown>): AdminFantasySearch => {
    const result: AdminFantasySearch = {}
    if (typeof search.competitionId === 'string' && search.competitionId) {
      result.competitionId = search.competitionId
    }
    return result
  },
  component: AdminFantasyPage,
})

function AdminFantasyPage() {
  const { competitionId } = Route.useSearch()
  const navigate = useNavigate()

  function setCompetition(id: string) {
    void navigate({
      to:     '/admin/fantasy',
      search: { competitionId: id },
      replace: true,
    })
  }

  return (
    <>
      <AppHeader title="Admin · Fantasy" />
      <div className={styles.page}>
        <Link to="/admin" className={styles.backLink}>
          <ChevronLeft size={14} />
          Escolher painel
        </Link>

        <p className={styles.frozenNotice}>
          O fantasy clássico está <strong>congelado</strong>. Estas ações continuam aqui para
          operar a competição existente — as que buscam dados de jogadores exigem
          <code> FootballData__Provider=API_FOOTBALL</code>.
        </p>

        <section className={styles.section}>
          <CompetitionPicker value={competitionId ?? null} onChange={setCompetition} />
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Rodadas</h2>
          <GameweekTable competitionId={competitionId ?? null} />
        </section>

        {competitionId && (
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Dados da Competição (API-Football)</h2>
            <SyncTeamsForm competitionId={competitionId} />
            <SyncScheduleForm competitionId={competitionId} />
            <SeedRostersForm competitionId={competitionId} />
            <SyncInjuriesForm competitionId={competitionId} />
            <SyncEliminationsForm competitionId={competitionId} />
          </section>
        )}

        {competitionId && (
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Preços</h2>
            <PricePreviewForm competitionId={competitionId} />
          </section>
        )}
      </div>
    </>
  )
}
